/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
import constantName from "./key"

export async function createFollowupRecord(record) {
  try {
    const response = await api.post(`/add_lead_${atob(constantName)}`, record)
    //console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateFollowupRecord(record) {
  try {
    const response = await api.post(
      `/update_lead_${atob(constantName)}`,
      record
    )
    //console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export function loadRecordsMetaData(metaData, method, params = {}) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`, params)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

export function loadCompanyMetaDataDetails(metaData, method, params = {}) {
  if (method === "post") {
    return api
      .post(`/get_${metaData}`, params)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

export async function loadRecordsFollowHistoryRecordData(record) {
  try {
    const response = await api.post(
      `/get_${atob(constantName)}_history`,
      record
    )
    //console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function loadRecordsAttachmentDetailData() {
  try {
    const response = await api.get(`/get_all_call_upload`)
    //console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function loadRecordsFollowOverallLeadStatusData(record) {
  try {
    const response = await api.post(`/get_overall_lead_status`, record)
    //console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function loadRecordsLeadCarryForwardListData(
  leadCarryForwardDetail
) {
  try {
    const response = await api.post(
      `/get_all_carry_forward_list`,
      leadCarryForwardDetail
    )
    //console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function uploadFollowupAttachmentRecordData(record) {
  try {
    console.log("recordrecord", record)
    const response = await api.put(`/update_by_call_upload_id`, record)
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function fileUploadFollowupAttachmentRecordData(record) {
  try {
    // const config = {
    //   headers: {
    //       'content-type': 'multipart/form-data'
    //   }
    // }
    const response = await api.post(`/image_upload`, record)
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
export async function rejectStatusApi(reject_Status) {
  return await api
    .put(`/update_rejectreason_by_id`, reject_Status)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function followupHistoryDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_followup_history`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function loadFollowupDetailsList(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_all_current_followup_list`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadRejectReasonList() {
  let payload = { status: "active" }

  return api
    .post(`/get_all_rejectreason`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function followupCronDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/cron_job_update_lead_followup_status`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  createFollowupRecord,
  loadRecordsMetaData,
  updateFollowupRecord,
  loadRecordsFollowHistoryRecordData,
  loadRecordsFollowOverallLeadStatusData,
  loadRecordsAttachmentDetailData,
  uploadFollowupAttachmentRecordData,
  fileUploadFollowupAttachmentRecordData,
  rejectStatusApi,
  followupHistoryDetails,
  followupCronDetails,
  loadFollowupDetailsList,
  loadRejectReasonList,
  loadCompanyMetaDataDetails,
}

export default remotes
